<script>
export default {
	props: ['order', 'checkout'],
}
</script>

<template>
	<CashCardContent :message="order.payments[0].data.message" />
</template>
